import MedicationPage from "./MedicationPage";

export default MedicationPage;